import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export const useGSAPAnimations = () => {
  const setupAnimations = () => {
    // Animaciones de scroll para los elementos decorativos
    const elements = gsap.utils.toArray<HTMLElement>('.shadow-plus-companion')
    elements.forEach(element => {
      gsap.to(element, {
        y: window.innerHeight,
        scrollTrigger: {
          trigger: element,
          start: 'top top',
          end: 'bottom bottom',
          scrub: 1,
          toggleActions: 'play none none reverse',
        },
        ease: 'none',
      })
    })

    // Animaciones para la rejilla de servicios
    const leftElements = gsap.utils.toArray<HTMLElement>('.animate-enter-left')
    leftElements.forEach(element => {
      gsap.set(element, {
        opacity: 0,
        x: -100,
        rotation: -33,
        visibility: 'hidden',
      })

      gsap.to(element, {
        opacity: 1,
        x: 0,
        rotation: 0,
        visibility: 'visible',
        duration: 1,
        scrollTrigger: {
          trigger: element,
          start: 'top bottom-=300',
          toggleActions: 'play none none reverse',
        },
        ease: 'power2.out',
      })
    })

    const rightElements = gsap.utils.toArray<HTMLElement>('.animate-enter-right')
    rightElements.forEach(element => {
      gsap.set(element, {
        opacity: 0,
        x: 100,
        rotation: 33,
        visibility: 'hidden',
      })

      gsap.to(element, {
        opacity: 1,
        x: 0,
        rotation: 0,
        visibility: 'visible',
        duration: 1,
        scrollTrigger: {
          trigger: element,
          start: 'top bottom-=300',
          toggleActions: 'play none none reverse',
        },
        ease: 'power2.out',
      })
    })

    const bottomElements = gsap.utils.toArray<HTMLElement>('.animate-enter-bottom')
    bottomElements.forEach(element => {
      gsap.set(element, {
        opacity: 0,
        y: 100,
        visibility: 'hidden',
      })

      gsap.to(element, {
        opacity: 1,
        y: 0,
        visibility: 'visible',
        duration: 1,
        scrollTrigger: {
          trigger: element,
          start: 'top bottom-=300',
          toggleActions: 'play none none reverse',
        },
        ease: 'power2.out',
      })
    })
  }

  const cleanup = () => {
    ScrollTrigger.getAll().forEach(trigger => trigger.kill())
  }

  return {
    setupAnimations,
    cleanup,
  }
}
